export enum UserManagementFormType {
    REPLACE = 'REPLACE',
    REMOVE = 'REMOVE',
}
